export const icid = {
  // Daily Curation - Grid (top section)
  pkgArticle: 'msd_topgrid',
  // Daily Curation - Columnists (bottom section)
  pkgColumnist: 'msd_botgrid',
  // Standard Daily in-line recirc module
  recircArticleBody: 'msd_recirc',
  // Columnist in-line recirc module
  recircColumnist: 'msd_columnrecirc',
  // Bottom Daily recirc module
  recircArticleBottom: 'msd_botrecric',
  // Daily Curation - Link to newsletter signup (will add via curator)
  // icid=msd_nlsignup
};

export function appendTracking(url, type) {
  // Not a string or already has tracking
  if (typeof url === 'string' && /[?&]icid=.+/.test(url) === false) {
    const { [type]: icidCode } = icid;
    if (typeof icidCode !== 'undefined') {
      return `${url}${url.indexOf('?') === -1 ? '?' : '&'}icid=${icidCode}`;
    }
  }
  return url;
}

export function appendTrackingUnibrow(unibrow, type) {
  const modified = { ...unibrow };
  if (typeof modified.url !== 'undefined') {
    if (typeof modified.url.override !== 'undefined') {
      modified.url.override = appendTracking(modified.url.override, type);
    }
    if (typeof modified.url.primary !== 'undefined') {
      modified.url.primary = appendTracking(modified.url.primary, type);
    }
  }
  return modified;
}
